
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import api from '../../service/api';
import ClientLink from '../../model/ClientLinkListElement';
import ConfirmDelete from './ConfirmDelete.vue';
import ConfirmationModel from '../ConfirmationModel';
import { getModule } from 'vuex-module-decorators';
import SessionsModule from '../../store/modules/Sessions';
import store from '../../store';
import LinkItem from './link-dialog/LinkItem.vue';

const sessionsModule = getModule(SessionsModule, store);

@Component({
    components: {
        ConfirmDelete,
        LinkItem,
    }
})
export default class LinkDialog extends Vue {
    @Prop({
        required: true,
        type: String
    })
    public sessionId!: string;
    public links: ClientLink[] = [];

    public waitingForIndividual = false;
    public generatedIndividualLink: ClientLink|null = null;

    public waitingForGroup = false;
    public generatedGroupLink: ClientLink|null = null;

    public inividualDialog = false;
    public groupDialog = false;

    public confirmationModel: ConfirmationModel = new ConfirmationModel();
    public isMounted: boolean = false;
    public loading: boolean = false;
    public deletingLink: boolean = false;

    async mounted() {
        await this.refreshLinks();
        Vue.nextTick(() => this.isMounted = true);
    }

    async refreshLinks() {
        this.loading = true;
        try {
            this.links = await api.getClientLinks(this.sessionId);
        } finally {
            this.loading = false;
        }
    }

    copyLink(link: ClientLink|null) {
        if (!link) return;

        navigator.clipboard.writeText(link.url);
        (this as any).$vToastify.success({
            title: 'Link w schowku',
            body: 'Wklej go swojemu klientowi!',
        });
    }

    async resetLink(link: ClientLink) {
        if (await this.confirmationModel.confirm('Czy zresetować ten link?')) {
            await api.resetLink(link.code);
            this.refreshLinks();
        }
    }

    generateMailto(link: ClientLink) {
        return `mailto:?subject=Link do sesji zdjęciowej&body=Adres sesji: ${link.url}`;
    }

    async generateIndividualLink() {
        this.waitingForIndividual = true;
        try {
            this.generatedIndividualLink = await api.generateLink(this.sessionId, false);
            this.links.push(this.generatedIndividualLink);
        } catch (e) {}
        this.waitingForIndividual = false;
    }

    async generateGroupLink() {
        this.waitingForGroup = true;
        try {
            this.generatedGroupLink = await api.generateLink(this.sessionId, true);
            this.links.push(this.generatedGroupLink);
        } catch (e) {}
        this.waitingForGroup = false;
    }

    public async deleteLink(linkCode: string) {
        if (await this.confirmationModel.confirm('Czy usunąć ten link?')) {
            this.deletingLink = true;
            try {
                await api.deleteLink(linkCode);
                this.links = this.links.filter(({ code }: any) => code !== linkCode);
                (this as any).$vToastify.success({ 
                    title: "Sukces", 
                    body: "Link został usunięty" 
                });
            } catch (error) {
                console.error("Error deleting link:", error);
                (this as any).$vToastify.error({ 
                    title: "Błąd", 
                    body: "Nie udało się usunąć linku" 
                });
            } finally {
                this.deletingLink = false;
            }
        }
    }

    @Watch('links', {
        deep: true
    })
    public onLinksChange(links: any[]) {
        if (!this.isMounted) {
            return;
        }

        if (links.length === 0) {
            sessionsModule.markSessionNotShared(this.sessionId);
        } else {
            sessionsModule.markSessionShared(this.sessionId);
        }
        this.$emit('linksChanged', links);
    }
}
